var React = require('react');

function NegativeChange (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6 12l5-5-1.414-1.414L7 8.17V0H5v8.171L2.414 5.586 1 7l5 5z","fill":"currentColor"}));
}

NegativeChange.defaultProps = {"width":"12","height":"12","fill":"none"};

module.exports = NegativeChange;

NegativeChange.default = NegativeChange;
